import { render } from "./SpecHead.vue?vue&type=template&id=63205be6&scoped=true"
import script from "./SpecHead.vue?vue&type=script&lang=js"
export * from "./SpecHead.vue?vue&type=script&lang=js"

import "./SpecHead.vue?vue&type=style&index=0&id=63205be6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63205be6"]])

export default __exports__